import { render, staticRenderFns } from "./dynamic-dialog.vue?vue&type=template&id=16a32145&scoped=true&"
import script from "./dynamic-dialog.vue?vue&type=script&lang=js&"
export * from "./dynamic-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16a32145",
  null
  
)

export default component.exports